// frontend/src/components/Login/Login.js

import React, { useState, useContext } from 'react';
import { login } from '../../api'; // Importera från api.js
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../UserContext';
import apiClient from '../../apiClient';
import './Login.css';
import logo from '../../assets/logo.png';
import { CeMark, MdSymbol } from '../common/MedicalDeviceMarks';
import { PRODUCT_INFO } from '../../constants/productInfo';

function Login() {
  const [username, setUsername] = useState(''); // Ändrad från email till username
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { setUser } = useContext(UserContext);
  const navigate = useNavigate();

  const handleLogin = async (event) => {
    event.preventDefault();
    try {
      const response = await login(username, password); // Använder login från api.js
      const access_token = response.access_token;
      localStorage.setItem('access_token', access_token); // Ändrad till 'access_token'
      console.log('Access Token Saved:', access_token); // Logga sparad token

      // Hämta användarinformation med Authorization header via interceptor
      const userResponse = await apiClient.get('/auth/user');
      setUser(userResponse.data);

      navigate('/'); // Omdirigera till huvudapplikationen
    } catch (error) {
      console.error("Inloggning misslyckades:", error);
      setError("Inloggning misslyckades. Kontrollera användarnamn och lösenord.");
    }
  };

  return (
    <div className="login-container">
      <div className="login-content">
        <img src={logo} alt="Company Logo" className="login-logo" />
        <h2>Logga In</h2>
        {error && <p className="error-message">{error}</p>}
        <form onSubmit={handleLogin} className="login-form">
          <div className="form-group">
            <input
              type="text" // Ändrad från email till text
              placeholder="Användarnamn" // Ändrad från "E-post" till "Användarnamn"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="login-input"
              required
            />
          </div>
          <div className="form-group">
            <input
              type="password"
              placeholder="Lösenord"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="login-input"
              required
            />
          </div>
          <button type="submit" className="login-button">
            Logga In
          </button>
        </form>
      </div>

      <footer className="login-footer">
        <div className="login-footer-marks">
          <CeMark size={22} />
          <MdSymbol size={22} />
        </div>
        <p className="login-footer-text">
          {PRODUCT_INFO.name} v{PRODUCT_INFO.version} · Medicinteknisk produkt (klass {PRODUCT_INFO.riskClass})
        </p>
        <p className="login-footer-mfr">Tillverkare: {PRODUCT_INFO.manufacturer.name}</p>
      </footer>
    </div>
  );
}

export default Login;
